module.exports = __webpack_public_path__ + "img/emoji_17.34c4b6f4.png";